import * as TYPES from "./types";

export default {
  [TYPES.SET_STATS](state, payload) {
    state.stats = payload.results;
  },
};
